var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "59px",
    viewBox: "0 0 62 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    stroke: "#1352DE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99999159,46.7473212 L17.2961831,40.2941032 L17.8332512,40.4603362 C21.0331938,41.4507807 24.4686789,41.9667969 28,41.9667969 C42.9607317,41.9667969 55,32.7223587 55,21.4667969 C55,10.2112351 42.9607317,0.966796875 28,0.966796875 C13.0392683,0.966796875 1,10.2112351 1,21.4667969 C1,27.1996024 4.13035068,32.5771955 9.57871487,36.4438994 L9.99995369,36.7428525 L9.99999159,46.7473212 Z",
    id: "Combined-Shape",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    strokeWidth: 2,
    strokeLinecap: "round",
    points: "48 51.6743152 54 57 54 49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,51.5369568 C37.0419951,54.7930932 28.0419951,52.6141077 21,45",
    id: "Path-5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,49 C61.7377544,41.8448813 63.0605613,34.1782146 57.9684207,26",
    id: "Path-6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.5535714,
    y1: 17.4667969,
    x2: 44,
    y2: 17.4667969,
    id: "Line-6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 26.4667969,
    x2: 31,
    y2: 26.4667969,
    id: "Line-6-Copy",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.96987f8772d70b9b989af8783065105f.svg";
export { ForwardRef as ReactComponent };